import { Product } from "@greeter/core";
import { Deserializer } from "./Deserializer";

export class ProductDeserializer extends Deserializer<Product> {
  override deserialize(json: any): Product {
    return json as Product;
  }
}
